/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LaunchRouteImport } from './routes/launch'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as EditorProjectIdRouteImport } from './routes/editor/$projectId'
import { Route as DocsSlugRouteImport } from './routes/docs/$slug'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LaunchRoute = LaunchRouteImport.update({
  id: '/launch',
  path: '/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorProjectIdRoute = EditorProjectIdRouteImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/editor/$projectId.lazy').then((d) => d.Route),
)
const DocsSlugRoute = DocsSlugRouteImport.update({
  id: '/docs/$slug',
  path: '/docs/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/docs/$slug': typeof DocsSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/docs/': typeof DocsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/docs/$slug': typeof DocsSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/docs': typeof DocsIndexRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/launch': typeof LaunchRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/docs/$slug': typeof DocsSlugRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/docs/': typeof DocsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/launch'
    | '/login'
    | '/register'
    | '/docs/$slug'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/docs/'
    | '/projects/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/launch'
    | '/login'
    | '/register'
    | '/docs/$slug'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/docs'
    | '/projects'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/launch'
    | '/login'
    | '/register'
    | '/docs/$slug'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/docs/'
    | '/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  LaunchRoute: typeof LaunchRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  DocsSlugRoute: typeof DocsSlugRoute
  EditorProjectIdRoute: typeof EditorProjectIdRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  DocsIndexRoute: typeof DocsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/launch': {
      id: '/launch'
      path: '/launch'
      fullPath: '/launch'
      preLoaderRoute: typeof LaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/$projectId': {
      id: '/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/editor/$projectId'
      preLoaderRoute: typeof EditorProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/$slug': {
      id: '/docs/$slug'
      path: '/docs/$slug'
      fullPath: '/docs/$slug'
      preLoaderRoute: typeof DocsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  LaunchRoute: LaunchRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  DocsSlugRoute: DocsSlugRoute,
  EditorProjectIdRoute: EditorProjectIdRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  DocsIndexRoute: DocsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
